import { UserI } from "./user";

export class ResponseLDAPI{
  u : UserI;
  user : any;
  status : String;
  response : String;
}
